/** A large (enough) integer value indicating infinity saved in pipedrive field */
export const PIPEDRIVE_INFINITY = 9999